import dayjs from "dayjs";
import React, { useContext, useState } from "react";
import logo from "../assets/logo.png";
import GlobalContext from "../context/GlobalContext";
import { getMes } from "../util";
import DatePicker from "react-datepicker";
import Switch from "react-switch";
import { MultiSelect } from "react-multi-select-component";
import Swal from "sweetalert2";

const ID_TP_COMP_FERIAS = "264f9e189b3297f77f48ac63e81c0346";
const ID_TP_COMP_FOLGA = "264f9e189b3297f77f48ac63e81c5ce3";
const ID_TP_COMP_LICENCA_MATERNIDADE =
  "55605cd248a9be824f0228922ff0e739";
const ID_TP_COMP_CONGRESSO = "55605cd248a9be824f0228922ff0ba48";
const ID_TP_COMP_LICENCA_SAUDE = "55605cd248a9be824f0228922ff0e5d4";
const ID_TP_COMP_CURSO = "55605cd248a9be824f0228922ff0bdf3"; //BORDO

let listaTipoCompromissosEscalador = [
  ID_TP_COMP_FERIAS,
  ID_TP_COMP_FOLGA,
  ID_TP_COMP_LICENCA_MATERNIDADE,
  ID_TP_COMP_CONGRESSO,
  ID_TP_COMP_LICENCA_SAUDE,
  ID_TP_COMP_CURSO,
];

const customStrings = {
  allItemsAreSelected: "Todos",
  clearSearch: "Limpar busca",
  noOptions: "Nenhuma opção",
  search: "Buscar",
  selectAll: "Selecionar todos",
  selectSomeItems: "Selecione os itens...",
  selectAllFiltered: "Selecionar todos (filtrados)",
};

const customStringsAnestesista = {
  ...customStrings,
  allItemsAreSelected: "Todos Anestesistas",
};

export default function CalendarHeader() {
  const { monthIndex, setMonthIndex } = useContext(GlobalContext);
  const { tipoFiltro, setTipoFiltro } = useContext(GlobalContext);
  const [tipoFiltroLocal, setTipoFiltroLocal] = useState(0);
  const { dtInicial, setDtInicial } = useContext(GlobalContext);
  const { dtFinal, setDtFinal } = useContext(GlobalContext);

  const [dtInicialLocal, setDtInicialLocal] = useState(dtInicial);
  const [dtFinalLocal, setDtFinalLocal] = useState(dtFinal);

  const { filtrarTiposCompromisso, setFiltrarTiposCompromisso } =
    useContext(GlobalContext);

  const { savedEventsBkp } = useContext(GlobalContext);

  const { savedEvents, dispatchCalEvent } = useContext(GlobalContext);

  const { listaTiposCompromisso } = useContext(GlobalContext);
  const { listaMedicos, listaMedicosBkp } = useContext(GlobalContext);
  const { listaMedicosSelecionados, setListaMedicosSelecionados } =
    useContext(GlobalContext);
  const {
    listaTiposCompromissoSelecionados,
    setListaTiposCompromissoSelecionados,
  } = useContext(GlobalContext);

  function handlePrevMonth() {
    setMonthIndex(monthIndex - 1);
  }
  function handleNextMonth() {
    setMonthIndex(monthIndex + 1);
  }
  function handleReset() {
    setMonthIndex(
      monthIndex === dayjs().month()
        ? monthIndex + Math.random()
        : dayjs().month()
    );
  }
  function filtrar() {
    if (tipoFiltroLocal === 4) {
      if (dtInicialLocal.isAfter(dtFinalLocal)) {
        // alert("Data inicial deve ser menor que a data final!");
        exibirMensagemErro(
          "Data Inicial deve ser menor que a Data Final!"
        );
        return false;
      }
    }
    setDtInicial(dtInicialLocal);
    setDtFinal(dtFinalLocal);
    setTipoFiltro(tipoFiltroLocal);
    filtrarCompromissos();
  }

  function exibirMensagemErro(msg) {
    Swal.fire({
      title: msg,
      icon: "warning",
      showCancelButton: true,
      showConfirmButton: false,
      cancelButtonText: "Fechar",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        // setTimeout(() => {
        //   handleSubmit(e, false, true);
        // }, 1000);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
      }
    });
  }

  function filtrarCompromissos() {
    setFiltrarTiposCompromisso(false);

    let savedEventsLocal = savedEventsBkp;

    if (
      listaTiposCompromisso.length !==
      listaTiposCompromissoSelecionados.length
    ) {
      let localListaTiposCompromissoSelecionados =
        listaTiposCompromissoSelecionados.map((it) => it._id);

      savedEventsLocal = savedEventsLocal.filter(
        (it) =>
          it.tipoCompromisso !== null &&
          localListaTiposCompromissoSelecionados.includes(
            it.tipoCompromisso._id
          )
      );
    }

    if (listaMedicosSelecionados.length > 0) {
      if (
        listaMedicosBkp.length !== listaMedicosSelecionados.length
      ) {
        let localListaMedicosSelecionados =
          listaMedicosSelecionados.map((it) => it.codigo);

        savedEventsLocal = savedEventsLocal.filter((it) =>
          localListaMedicosSelecionados.includes(it.medico)
        );
      }
    }

    dispatchCalEvent({
      type: "atualiza",
      payload: savedEventsLocal,
    });
  }

  function handleChangeSwitchEscalador(isChecked) {
    let localListaTiposCompromisso = listaTiposCompromisso;

    if (!isChecked) {
      setListaTiposCompromissoSelecionados(
        localListaTiposCompromisso
      );

      setListaMedicosSelecionados(listaMedicosBkp);

      dispatchCalEvent({
        type: "atualiza",
        payload: savedEventsBkp,
      });
    } else {
      localListaTiposCompromisso = localListaTiposCompromisso.filter(
        (it) => listaTipoCompromissosEscalador.includes(it._id)
      );
      setListaTiposCompromissoSelecionados(
        localListaTiposCompromisso
      );

      let savedEventsLocal = savedEventsBkp;

      savedEventsLocal = savedEventsLocal.filter(
        (it) =>
          it.tipoCompromisso !== null &&
          listaTipoCompromissosEscalador.includes(
            it.tipoCompromisso._id
          )
      );

      if (listaMedicosSelecionados.length > 0) {
        if (
          listaMedicosBkp.length !== listaMedicosSelecionados.length
        ) {
          let localListaMedicosSelecionados =
            listaMedicosSelecionados.map((it) => it.codigo);

          savedEventsLocal = savedEventsLocal.filter((it) =>
            localListaMedicosSelecionados.includes(it.medico)
          );
        }
      }

      dispatchCalEvent({
        type: "atualiza",
        payload: savedEventsLocal,
      });
    }

    // filtrarCompromissos(isChecked);
  }

  return (
    <React.Fragment>
      <header
        className="px-4 py-2 flex items-center"
        style={{ position: "relative" }}
      >
        {/* <img src={logo} alt="calendar" className="mr-2 w-12 h-12" />
      <h1 className="mr-10 text-xl text-gray-500 fond-bold">
        Agenda
      </h1> */}

        {/* <button
        onClick={handleReset}
        className="border rounded py-2 px-4 mr-5"
      >
        Hoje
      </button> */}

        <div>
          <select
            className="pt-3 border-0 text-gray-600 text-x2 font-semibold pb-2 w-full border-b-2 border-gray-200 focus:outline-none focus:ring-0 focus:border-blue-500"
            value={tipoFiltroLocal}
            onChange={(e) =>
              setTipoFiltroLocal(parseInt(e.target.value))
            }
            style={{
              border: "1px solid #ccc",
              borderRadius: "4px",
              paddingTop: "7px",
              paddingBottom: "7px",
            }}
          >
            <option value={0}>Mensal</option>
            <option value={1}>Próximos 7 Dias</option>
            <option value={2}>Próximos 14 Dias</option>
            <option value={3}>Próximos 30 Dias</option>
            <option value={4}>Personalizado</option>
          </select>
        </div>
        <div
          style={{
            maxWidth: "250px",
            minWidth: "250px",
            marginLeft: "10px",
          }}
        >
          <MultiSelect
            options={listaTiposCompromisso}
            value={listaTiposCompromissoSelecionados}
            onChange={(value) =>
              setListaTiposCompromissoSelecionados(value)
            }
            labelledBy="Selecione"
            className="rodrigo"
            className2="pt-3 border-0 text-gray-600 text-xl font-semibold pb-2 w-full border-b-2 border-gray-200 focus:outline-none focus:ring-0 focus:border-blue-500"
            overrideStrings={customStrings}
          />
        </div>
        <div
          style={{
            maxWidth: "250px",
            minWidth: "250px",
            marginLeft: "10px",
          }}
        >
          <MultiSelect
            options={listaMedicosBkp}
            value={listaMedicosSelecionados}
            onChange={(value) => setListaMedicosSelecionados(value)}
            labelledBy="Selecione"
            className="rodrigo"
            className2="pt-3 border-0 text-gray-600 text-xl font-semibold pb-2 w-full border-b-2 border-gray-200 focus:outline-none focus:ring-0 focus:border-blue-500"
            overrideStrings={customStringsAnestesista}
          />
        </div>

        {tipoFiltroLocal === 4 && (
          <React.Fragment>
            <div style={{ marginLeft: "10px", width: "110px" }}>
              <DatePicker
                selected={dtInicialLocal.toDate()}
                withPortal
                customInput={
                  <input
                    className="pt-3 border-0 text-gray-600 text-x2 font-semibold pb-2 w-full border-b-2 border-gray-200 focus:outline-none focus:ring-0 focus:border-blue-500 text-center"
                    style={{
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                      paddingTop: "7px",
                      paddingBottom: "7px",
                    }}
                  />
                }
                dateFormat="dd/MM/yyyy"
                onChange={(value) => setDtInicialLocal(dayjs(value))}
                locale="pt-BR"
              />
            </div>
            <span style={{ marginLeft: "10px" }}>à</span>
            <div style={{ marginLeft: "10px", width: "110px" }}>
              <DatePicker
                selected={dtFinalLocal.toDate()}
                withPortal
                customInput={
                  <input
                    className="pt-3 border-0 text-gray-600 text-x2 font-semibold pb-2 w-full border-b-2 border-gray-200 focus:outline-none focus:ring-0 focus:border-blue-500 text-center"
                    style={{
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                      paddingTop: "7px",
                      paddingBottom: "7px",
                    }}
                  />
                }
                dateFormat="dd/MM/yyyy"
                onChange={(value) => setDtFinalLocal(dayjs(value))}
                locale="pt-BR"
              />
            </div>
          </React.Fragment>
        )}

        <div style={{ marginLeft: "10px" }}>
          <button
            className="bg-gray-300 text-gray-800 border border-gray-400 hover:bg-gray-400 font-semibold py-2 px-4 rounded"
            style={{ backgroundColor: "#6c757d" }}
            onClick={() => filtrar()}
          >
            <i className="fa fa-filter" style={{ color: "#FFF" }}></i>
          </button>
        </div>

        {tipoFiltroLocal === 0 && (
          <div className="flex" style={{ marginLeft: "20px" }}>
            <h2 className="text-xl text-gray-500 font-bold">
              {getMes(
                dayjs(new Date(dayjs().year(), monthIndex)).format(
                  "MM"
                )
              )}
              &nbsp;
              {dayjs(new Date(dayjs().year(), monthIndex)).format(
                "YYYY"
              )}
            </h2>

            <button onClick={handlePrevMonth}>
              <span className="material-icons-outlined cursor-pointer text-gray-600 mx-2">
                chevron_left
              </span>
            </button>
            <button onClick={handleNextMonth}>
              <span className="material-icons-outlined cursor-pointer text-gray-600 mx-2">
                chevron_right
              </span>
            </button>
          </div>
        )}
      </header>

      <div
        className="px-4 py-2 flex items-center"
        style={{ position: "relative" }}
      >
        <div
          className="item-switch"
          style={{
            display: "flex",
            marginBottom: "10px",
            paddingLeft: "10px",
          }}
        >
          <span style={{ marginRight: "15px" }}>
            Agenda Escalador ?
          </span>
          <Switch
            checked={filtrarTiposCompromisso}
            onChange={(isChecked) => {
              setFiltrarTiposCompromisso(isChecked);
              handleChangeSwitchEscalador(isChecked);
            }}
            onColor="#8c9a9a"
            onHandleColor="#244973"
            handleDiameter={22}
            uncheckedIcon={false}
            checkedIcon={false}
            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
            height={15}
            width={45}
          />
        </div>
      </div>
    </React.Fragment>
  );
}
